import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { ApiService, Constants, objectToParams, RegisteredSecurityStockByCompany, SecurityStockCes, SecurityStockRequest, SecurityStockUpdateResponse } from '../../core';
import { Observable, throwError } from 'rxjs';
import { SecurityStockRegisterResponse } from '../../core/models/configuration-system/centralized-security-stock/security-stock-register-response.model';
import { RegisteredSecurityStock } from '../../core/models/configuration-system/centralized-security-stock/registered-security-stock.model';
import { STOCK_LEVEL } from '../../core/enums/centralized-stock-configuration/stock-level.enum';
import { HIERARCHY_LEVEL } from '../../core/enums/centralized-stock-configuration/hierarchy-level.enum';
import { SUPERMERCADOS_CODE } from '../../core/configs/company.config';
@Injectable({
  providedIn: 'root'
})
export class SecurityStockCesService {
  constructor(
    public apiService: ApiService
  ) { }

  getAllSecurityStock(request:any): Observable<RegisteredSecurityStock[]> {
    return this.apiService
    .get(`${this.apiService.securityStockCes}?${objectToParams(request)}`)
    .pipe(map(data => data));
  }

  getSecurityStockByCompanyCode(companyCode: String): Observable<RegisteredSecurityStockByCompany[]> {
    return this.apiService
    .get(`${this.apiService.securityStockCes}/company?companyCode=${companyCode}`)
    .pipe(map(data => data));
  }

  updateSecurityStockById(request: any, id: number): Observable<SecurityStockUpdateResponse> {
    return this.apiService.put(this.apiService.securityStockCes + "/" + id, request).pipe();
  }

  saveSecurityStock(request: SecurityStockRequest[]): Observable<SecurityStockRegisterResponse> {
    return this.apiService.post(this.apiService.securityStockCes, request).pipe();
  }

  readId(id): Observable<SecurityStockCes> {
    return this.apiService
      .get(`${this.apiService.securityStockCes}/${id}`)
      .pipe(map(data => data),
      catchError(this.handleError));
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(error);
  }

  parseHierarchyLevel(value: string): string | null {
    let hierarchyFounded: any
    if (value) {      
      hierarchyFounded = Constants.hierarchyLevels.find(hierarchy => hierarchy.text.toUpperCase() === value.toUpperCase());
    }
    return hierarchyFounded ? hierarchyFounded.value : null;
  }
  
  structuraData(form: any, companyCode: String) {
    const allRequest: any[] = [];

    if(form.entity && form.entity.entityCode && form.quantity) {
      const request = {
        stockLevel: STOCK_LEVEL.ENTITY,
        companyCode: companyCode,
        entityCode: form.entity.entityCode,
        entityName: form.entity.entityName,
        entityType: form.entity.entityType,
        securityStock: form.quantity
      }
      allRequest.push(request)
    }

    if(form.hierarchy && form.hierarchy.length > 0) {
      form.hierarchy.forEach(element => {
        if (element.hierarchyCode && form.securityStockByHierarchy) {       
          const hierarchyFounded: String = this.parseHierarchyLevel(element.hierarchyName);
            const requestByHierarchy = {
               stockLevel: STOCK_LEVEL.HIERARCHY,
               companyCode: companyCode,
               entityType: form.entity && form.entity.entityType? form.entity.entityType: null,
               entityCode: form.entity && form.entity.entityCode? form.entity.entityCode: null,
               entityName: form.entity && form.entity.entityCode? form.entity.entityName: null,
              hierarchyName: hierarchyFounded ? hierarchyFounded
                : (companyCode === SUPERMERCADOS_CODE
                  ? HIERARCHY_LEVEL.AREA
                  : HIERARCHY_LEVEL.DIVISION
                ),
               hierarchyCode: element.hierarchyCode,
               hierarchyDescription: element.hierarchyDescription,
               securityStock: form.securityStockByHierarchy
            }
            allRequest.push(requestByHierarchy)
        }
        
      });
    }
    
    return allRequest;
  }
}
